/**
 * FullTextTestPage
 * Test page for FullTextMode component using published course data
 */

import React from 'react';
import FullTextMode from '../components/learning/FullTextMode';

import { resolveMediaUrl } from '../utils/mediaUrl';

const FullTextTestPage: React.FC = () => {
    // Using the FINAL audio with 0.2s silence gaps (29 segments)
    const courseId = '51a056c3-b29d-4741-9cb9-5645d7f08b82';
    const episodeId = '642f0de5-f933-49fb-bbfd-eddb3fc2b6fa';
    const audioUrl = resolveMediaUrl('/uploads/audio/merged_bc489d6c-a681-45ab-a85d-6aa969d1cdd0_1764817246079.mp3');

    return (
        <div style={{ width: '100%', height: '100vh' }}>
            <div style={{
                padding: '20px',
                background: '#667eea',
                color: 'white',
                textAlign: 'center'
            }}>
                <h1>🎧 Full Text Learning Mode - Test</h1>
                <p style={{ fontSize: '14px', opacity: 0.9, marginTop: '8px' }}>
                    Course: Test Publishing - Coffee Shop Dialogue (A2 CEFR)
                </p>
            </div>

            <FullTextMode
                episodeId={episodeId}
                audioUrl={audioUrl}
                courseId={courseId}
            />
        </div>
    );
};

export default FullTextTestPage;
